









































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import Document from "@/models/document.model";
import ContentType from "@/models/porposal/contentTeype.Model";
import documentTable from "@/components/document-component-view/table.vue";
@Component({
  components: {
    documenttable: documentTable
  }
})
export default class DocumentComponentViewerComponent extends BaseVue {
  @Prop() readonly title!: string;
  @Prop() readonly selecteds!: Document[];
  @Prop() readonly disabled!: boolean;

  refName: string = "user";
  refKey: string = "id";
  contentTypes: any[] = [];
  documents: any[] = [];
  ContentTypeDocRepo = new BaseRepository<ContentType>("ContentTypes");

  get refValue() {
    return this.$store.state.user ? this.$store.state.user.id : 0;
  }

  async mounted() {
    //let contentTypes = ((await this.ContentTypeDocRepo.get()) as any).data;
     this.ContentTypeDocRepo.get().then((result: any) => {
        this.contentTypes = [];
        result.data.forEach((x: any) => {
          let doc = this.copy(x);
          doc.fileSelected = this.selecteds
            ? this.selecteds.find(y => y.contentTypeId === x.id)
            : null;
          this.contentTypes.push(doc);
        });
      });
  }

  @Watch("selecteds")
  async onDocsChange(value: Document[]) {
    if (value && value.length > 0) {
      this.ContentTypeDocRepo.get().then((result: any) => {
        this.contentTypes = [];
        result.data.forEach((x: any) => {
          let doc = this.copy(x);
          doc.fileSelected = value
            ? value.find(y => y.contentTypeId === x.id)
            : null;
          this.contentTypes.push(doc);
        });
      });
    }
  }

  onSelectDoc(doc: Document) {
    let found = this.contentTypes.find(x => x.id === doc.contentTypeId);
    found.fileSelected = doc;
    for (let index = 0; index < this.documents.length; index++) {
      const x = this.documents[index];
      if (x.contentTypeId == doc.contentTypeId) {
        this.documents.splice(index, 1);
        break;
      }
    }
    let file = {
      contentTypeId: doc.contentTypeId,
      contentTypeNombre: found.contentTypeNombre
    } as any;
    if (doc.id) file.documentId = doc.id;
    else file.document = doc;
    this.$emit("select", file);

    this.documents.push(file);

    this.$emit("change", this.contentTypes, this.documents);
  }
  onRemoveDoc(doc: Document) {
    this.$emit("remove", doc);
    let found = this.contentTypes.find(x => x.id === doc.contentTypeId);
    found.fileSelected = null;
    for (let index = 0; index < this.documents.length; index++) {
      const x = this.documents[index];
      if (x.contentTypeId == doc.contentTypeId) {
        this.documents.splice(index, 1);
        break;
      }
    }
    this.$emit("change", this.contentTypes, this.documents);
  }
}
